import { Phone, MessageCircle, FileText } from "lucide-react";
import { Link } from "react-router-dom";
import { PHONE_TEL, WHATSAPP_URL } from "../lib/site";

export default function Overlays() {
  return (
    <>
      <a
        href={WHATSAPP_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="group fixed bottom-24 right-4 z-50 flex items-center gap-0 rounded-full bg-mint p-4 text-white shadow-mint transition-all duration-300 hover:bg-mint-600 md:bottom-6 md:right-6"
        aria-label="Chat with PocketBima on WhatsApp"
        data-testid="whatsapp-float-button"
      >
        <MessageCircle className="h-6 w-6" />
        <span className="max-w-0 overflow-hidden whitespace-nowrap text-sm font-bold transition-all duration-300 group-hover:ml-2 group-hover:max-w-[180px]">
          Chat with PocketBima
        </span>
      </a>

      <div
        className="fixed inset-x-0 bottom-0 z-40 grid grid-cols-3 border-t border-navy/10 bg-white/95 backdrop-blur-xl md:hidden"
        data-testid="mobile-sticky-cta"
      >
        <a
          href={PHONE_TEL}
          className="flex items-center justify-center gap-2 py-4 text-sm font-bold text-navy"
          data-testid="sticky-call-button"
        >
          <Phone className="h-4 w-4 text-mint" /> Call
        </a>
        <a
          href={WHATSAPP_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center gap-2 border-x border-navy/10 py-4 text-sm font-bold text-navy"
          data-testid="sticky-whatsapp-button"
        >
          <MessageCircle className="h-4 w-4 text-mint" /> WhatsApp
        </a>
        <Link
          to="/contact"
          className="flex items-center justify-center gap-2 bg-mint py-4 text-sm font-bold text-white"
          data-testid="sticky-quote-button"
        >
          <FileText className="h-4 w-4" /> Get Quote
        </Link>
      </div>
    </>
  );
}
